<template>
  <div>
    <div class="navbar__wrap">
      <nav class="siteNav">
        <div class="container">
          <div class="siteNav__col">
            <!-- <router-link class="navbar-brand" to="/horoscope" v-if="auth_mobis === 'loggedin'">
              <img src="../../assets/mobiscope/imgs/mobiscope-logo.png" />
            </router-link>
            <a class="navbar-brand" v-else>
              <img src="../../assets/mobiscope/imgs/mobiscope-logo.png" />
            </a> -->
            <router-link class="navbar-brand" :to="auth_mobis === 'loggedin' || auth_mobis === 'guest'  ? '/home' : ''">
              <img src="../../assets/mobiscope/imgs/mobiscope-logo.png" />
            </router-link>
            <!-- desktop -->
            <ul class="navLinks">
              <li class="navLinks__item active">
                <router-link style="text-decoration:none;" to="/horoscope" class="text_col" v-if="auth_mobis === 'loggedin'">{{ $t("horoscope") }}</router-link>
                <a class="text_dummmy" @click="guest_mobis()" v-if="auth_mobis === 'guest'">{{ $t("horoscope") }}</a>
              </li>
              <li class="navLinks__item">
                <router-link style="text-decoration:none;" to="/tarot" class="text_col" v-if="auth_mobis === 'loggedin'">{{ $t("tarot") }}</router-link>
                <a class="text_dummmy" @click="guest_mobis()" v-if="auth_mobis === 'guest'">{{ $t("tarot") }}</a>
              </li>
              <!-- <li class="navLinks__item">
                <router-link style="text-decoration:none;" to="/zodiac" class="text_col" v-if="auth_mobis === 'loggedin'">{{ $t("zodiac_signs") }}</router-link>
                <a class="text_dummmy" @click="guest_mobis()" v-if="auth_mobis === 'guest'">{{ $t("zodiac_signs") }}</a>
              </li> -->
              <li class="navLinks__item dropdown">
                <router-link style="text-decoration:none;" to="/chinesezodiac" class="text_col" v-if="auth_mobis === 'loggedin'">{{ $t("chinese_zodiac") }}</router-link>
                <a class="text_dummmy" @click="guest_mobis()" v-if="auth_mobis === 'guest'">{{ $t("chinese_zodiac") }}</a>
              </li>
              <li v-if="countryCode === 'cz' || countryCode === 'sk'" class="navLinks__item dropdown">
                <router-link style="text-decoration:none;" class="text_col" to="/privacy" >{{ $t("privacy") }}</router-link>
                
              </li>
              <li v-if="countryCode === 'cz'|| countryCode === 'sk'"  class="navLinks__item dropdown">
                <router-link style="text-decoration:none;"  to="/terms" >{{ $t("terms") }}</router-link>
              </li>
              
              <li class="navLinks__item dropdown"></li>
            </ul>
          </div>
          <div class="siteNav__col">
            <div class="langPanel">
              <button id="lang1" lang="english" class="lang1">
                <img lang="english" src="https://i.imgur.com/oi8qUPx.png" />
                <span lang="english" style="text-transform: uppercase">English</span>
              </button>
              <div v-html="langButton" id="lang2" class="langButton"></div>
            </div>
            <div class="accountInfo">
              <div v-if="auth_mobis == ''">
                <!-- <router-link style="text-decoration:none;" class="login_btn" to="/login">
                  <img class="icon" src="../../assets/mobiscope/imgs/user_icon.png" /> Log in
                </router-link>-->
                <!-- <router-link style="text-decoration:none;" class="sign_btn" to="/signup">Sign up</router-link> -->
              </div>
              <div v-if="auth_mobis === 'loggedin'">
                 <router-link v-if="countryCode === 'om' || countryCode === 'gr'" style="text-decoration:none;" class="login_btn" to="/profile">
                   <img class="icon" src="../../assets/mobiscope/imgs/user_icon.png" /> {{ $t("profile") }}
                 </router-link>
                <a v-if="countryCode !== 'fi'" style="text-decoration:none;" class="login_btn" href="/logout" @click="logout()">{{ $t("logout") }}</a>
              </div>
            </div>
            <button class="menuBtn" id="menuBtn">
              <span class="menuBtn__inner">menu</span>
            </button>
          </div>
        </div>
      </nav>
      <!-- mobile -->
      <nav class="siteNavMobile">
        <ul class="navLinks">
          <li class="navLinks__item">
            <router-link style="text-decoration:none;" to="/horoscope" v-if="auth_mobis === 'loggedin'">{{ $t("horoscope") }}</router-link>
            <a class="text_dummmy" @click="guest_mobis()" v-if="auth_mobis === 'guest'">{{ $t("chinese_zodiac") }}</a>
          </li>
          <li class="navLinks__item">
            <router-link style="text-decoration:none;" to="/tarot" v-if="auth_mobis === 'loggedin'">{{ $t("tarot") }}</router-link>
            <a class="text_dummmy" @click="guest_mobis()" v-if="auth_mobis === 'guest'">{{ $t("tarot") }}</a>
          </li>
          <!-- <li class="navLinks__item">
            <router-link style="text-decoration:none;" to="/zodiac" v-if="auth_mobis === 'loggedin'">{{ $t("zodiac_signs") }}</router-link>
            <a class="text_dummmy" @click="guest_mobis()" v-if="auth_mobis === 'guest'">{{ $t("zodiac_signs") }}</a>
          </li> -->
         <li class="navLinks__item">
           <router-link v-if="countryCode === 'om' || countryCode === 'gr'" style="text-decoration:none;" class="login_btn" to="/profile">
              <a class="text_dummmy" v-if="auth_mobis === 'loggedin'">{{ $t("profile") }}</a>
                  
            </router-link>
          </li>
          <li class="navLinks__item">
            <router-link style="text-decoration:none;" to="/chinesezodiac" v-if="auth_mobis === 'loggedin'">{{ $t("chinese_zodiac") }}</router-link>
            <a class="text_dummmy" @click="guest_mobis()" v-if="auth_mobis === 'guest'">{{ $t("chinese_zodiac") }}</a>
          </li>
          <li v-if="countryCode === 'cz' || countryCode === 'sk'"   class="navLinks__item">
                <router-link style="text-decoration:none;"  to="/privacy" >{{ $t("privacy") }}</router-link>
                
          </li>
          <li v-if="countryCode === 'sk'"  class="navLinks__item">
                <router-link style="text-decoration:none;"  to="/terms" >{{ $t("terms") }}</router-link>
          </li>
          
          <li class="navLinks__item">
            <div class="langPanel mobile">
              <button id="lang1" lang="english" class="lang1">
                <img lang="english" src="https://i.imgur.com/oi8qUPx.png"/>
                <span lang="english">ENGLISH</span>
              </button>
              <div v-html="langButton" id="lang2" class="langButton"></div>
            </div>
          </li>
          <li class="navLinks__item">
            <div class="accountInfo">
              <div v-if="auth_mobis == ''">
                <!-- <router-link style="text-decoration:none;" class="login_btn" to="/login">
                  <img class="icon" src="../../assets/mobiscope/imgs/user_icon.png" /> Log in
                </router-link>-->
                <!--router-link style="text-decoration:none;" class="sign_btn" to="/signup">Sign up</router-link-->
              </div>
              <div v-if="auth_mobis === 'loggedin'">
                <a style="text-decoration:none;" class="login_btn" href="/logout" @click="logout()">{{ $t("logout") }}</a>
              </div>
            </div>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</template>

<style scoped>
.text_dummmy{
  cursor: pointer;
}
</style>
<script>
import mobis_router from "../../router/mobiscope";
import EventBus from "../EventBus.vue";
import { mapGetters, mapActions } from "vuex";
import country_list from "../../locales/country_list.json";

export default {
  data() {
    return {
      auth: "",
      user: "",
      name: "",
    };
  },
  computed: mapGetters(["language", "countryCode", "langButton", "auth_mobis","host_mobiscope"]),
  created() {
    this.fetchTransButton(this.countryCode);
  },
  mounted() {
    // button translate
    const btnLang1 = document.getElementsByClassName("lang1");
    const btnLang2 = document.getElementsByClassName("lang2");

    let country_ls = Object.keys(country_list);

    if (this.language == "english") {
      if (country_ls.includes(this.countryCode)) {
        btnLang2[0].style.display = "inline-block";
        btnLang2[1].style.display = "inline-block";
        btnLang1[0].style.display = "none";
        btnLang1[1].style.display = "none";
      }
    } else {
      if (this.language == null && sessionStorage.getItem('tokenID') == 'mobis80') {
        btnLang2[0].style.display = "inline-block";
        btnLang2[1].style.display = "inline-block";
        btnLang1[0].style.display = "none";
        btnLang1[1].style.display = "none";
      }else{
        btnLang2[0].style.display = "none";
        btnLang2[1].style.display = "none";
        btnLang1[0].style.display = "inline-block";
        btnLang1[1].style.display = "inline-block";
      }
    }

    for (let i = 0; i < btnLang1.length; i++) {
      btnLang1[i].addEventListener("click", (e) => {
        let lang = e.target.getAttribute("lang");
        sessionStorage.setItem("language", lang);
        this.$i18n.locale = "english";
        this.fetchLang("english");
        btnLang2[i].style.display = "inline-block";
        btnLang1[i].style.display = "none";
        document.getElementsByTagName("html")[0].classList.remove("ar_layout");
      });
    }
    for (let i = 0; i < btnLang2.length; i++) {
      btnLang2[i].addEventListener("click", (e) => {
        let lang = e.target.getAttribute("lang");
        sessionStorage.setItem("language", lang);
        this.$i18n.locale = lang;
        this.fetchLang(lang);
        btnLang1[i].style.display = "inline-block";
        btnLang2[i].style.display = "none";
        if (lang == "arabic") {
          document.getElementsByTagName("html")[0].classList.add("ar_layout");
        } else {
          document.getElementsByTagName("html")[0].classList.remove("ar_layout");
        }
      });
    }

    document.onreadystatechange = () => {
      if (document.readyState == "complete") {
        const menuBtn = document.getElementById("menuBtn");
        menuBtn.addEventListener("click", () => {
          document.body.classList.toggle("mobile--active");
        });
        const mobileLinks = document.querySelectorAll(".siteNavMobile .navLinks__item");

        Object.keys(mobileLinks).map((elm) => {
          mobileLinks[elm].addEventListener("click", () => {
            document.body.classList.remove("mobile--active");
          });
        });
      }
    };
    // init mobile menu
  },
  methods: {
    ...mapActions(["fetchLang", "fetchTransButton", "guest_mobis"]),
    logout() {
      sessionStorage.removeItem("tokenID");
      sessionStorage.removeItem("logged-in");
      // localStorage.clear();
      mobis_router.push({ name: Login }).catch((err) => {});
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar__wrap {
  background: rgba(0, 0, 0, 0.45);
  position: relative;
  z-index: 9;
}

.siteNav {
  position: relative;
  z-index: 11;
  .navbar-brand {
    padding: 0px;
    vertical-align: middle;
    img {
      width: 120px;
    }
  }
  .container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 4rem;
  }
  .siteNav__col {
    align-items: center;
    &:last-child {
      display: flex;
      justify-content: flex-end;
    }
    &:first-child {
      // width: 50%;
      flex: 1 0 auto;
    }
  }
  .navLinks {
    display: inline-block;
    vertical-align: middle;
    margin: 0;
  }
  .navLinks__item {
    display: inline-block;
    vertical-align: middle;
    padding-right: 1.375rem;
    font-weight: 600;
    a {
      color: #fff;
      font-size: 1.1rem;
    }
  }
}
.accountInfo {
  .icon {
    width: 18px;
    margin-right: 5px;
  }
  a {
    display: inline-block;
    color: #fff;
    margin-left: 1.375rem;
    font-weight: 600;
  }
  .sign_btn {
    background: #fff;
    color: #571eee;
    padding: 3px 15px;
    border-radius: 25px;
    font-weight: 700;
  }
}

// Responsive menu styles
.login .menuBtn {
  display: none;
}
.menuBtn {
  display: none;
  border: 0;
  background: transparent;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  position: relative;
  width: 34px;
  height: 30px;
  cursor: pointer;
  outline: none;
  margin-left: 25px;
}
.menuBtn::before,
.menuBtn:after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 34px;
  height: 2px;
  background-color: #fff;
  transition-property: color, opacity, -webkit-transform;
  -webkit-transition-property: color, opacity, -webkit-transform;
  -o-transition-property: transform, color, opacity;
  transition-property: transform, color, opacity;
  transition-property: transform, color, opacity, -webkit-transform;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-in-out;
  -o-transition-timing-function: ease-in-out;
  transition-timing-function: ease-in-out;
  -webkit-transform-origin: center;
  -ms-transform-origin: center;
  transform-origin: center;
}
.menuBtn::before {
  top: 5px;
}
.menuBtn__inner {
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-align: left;
  text-indent: 100%;
  white-space: nowrap;
  cursor: pointer;
}
.menuBtn::after {
  top: 23px;
}
.menuBtn__inner {
  display: block;
  width: 100%;
  height: 100%;
  overflow: hidden;
  text-align: left;
  text-indent: 100%;
  white-space: nowrap;
  cursor: pointer;
}
.menuBtn__inner::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  margin-left: auto;
  margin-right: auto;
  width: 34px;
  height: 2px;
  background-color: #fff;
  transition-property: color, opacity, -webkit-transform;
  -webkit-transition-property: color, opacity, -webkit-transform;
  -o-transition-property: transform, color, opacity;
  transition-property: transform, color, opacity;
  transition-property: transform, color, opacity, -webkit-transform;
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-in-out;
  -o-transition-timing-function: ease-in-out;
  transition-timing-function: ease-in-out;
  -webkit-transform-origin: center;
  -ms-transform-origin: center;
  transform-origin: center;
  top: 14px;
}
.siteNavMobile {
  // display: none;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  width: 100%;
  color: #fff;
  padding: 5rem 1rem;
  background: #000000;
  -webkit-transform: translateX(100%);
  -ms-transform: translateX(100%);
  transform: translateX(100%);
  -webkit-transition: -webkit-transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  transition: -webkit-transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  -o-transition: transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  transition: transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  transition: transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1),
    -webkit-transform 0.6s cubic-bezier(0.075, 0.82, 0.165, 1);
  .navLinks {
    .navLinks__item {
      margin: 15px 0px;
    }
    .navLinks__item a {
      font-size: 2rem;
      color: #fff;
    }
  }
  .accountInfo a {
    margin-left: 0;
    font-size: 1.4rem !important;
    color: #767676 !important;
  }
}
.mobile--active .navbar__wrap {
  position: fixed;
  width: 100%;
}
.mobile--active .siteNavMobile {
  -webkit-transform: translateX(0);
  -ms-transform: translateX(0);
  transform: translateX(0);
}
.mobile--active .menuBtn::before {
  color: #fff;
  -webkit-transform: translateY(9px) rotate(135deg);
  -ms-transform: translateY(9px) rotate(135deg);
  transform: translateY(9px) rotate(135deg);
}
.mobile--active .menuBtn::after {
  color: #fff;
  -webkit-transform: translateY(-9px) rotate(45deg);
  -ms-transform: translateY(-9px) rotate(45deg);
  transform: translateY(-9px) rotate(45deg);
}
.mobile--active .menuBtn__inner::before {
  opacity: 0;
  -webkit-transition-duration: 0.1s;
  -o-transition-duration: 0.1s;
  transition-duration: 0.1s;
}
.langPanel.mobile {
  display: none;
}

.flag {
  width: 21px;
  margin-right: 5px;
}
.langPanel {
  button {
    color: #fff;
    background-color: transparent;
    padding: 4px;
    margin-right: 8px;
    border-radius: 0px;
    appearance: none;
    outline: none;
    border: 0;
    display: none;
    img {
      width: 21px;
      margin-right: 5px;
    }
    span {
      font-weight: 600;
      font-size: 1.1rem;
      vertical-align: middle;
    }
  }
}

/*##### Arabic layout Styles#####*/
.ar_layout {
  .siteNav .navLinks__item {
    padding-right: 0px !important;
    padding-left: 1.375rem;
  }
  .siteNav .navbar-brand {
    margin-right: 0;
    margin-left: 1rem;
  }
  .navLinks {
    padding-right: 0;
    padding-left: 1rem;
  }
}

@media (max-width: 991px) {
  .langPanel {
    display: none;
  }
  .langPanel.mobile {
    display: block;
  }
  .menuBtn {
    display: inline-block;
  }
  .siteNav {
    .accountInfo {
      display: none;
    }
  }

  .container {
    max-width: 100%;
  }
  .siteNav {
    .navLinks {
      display: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobiscope/Navigation.vue